import { useFormik } from "formik"
import { Button, Checkbox, Dialog, Grid} from "src/components"
import DialogActions from "src/components/DialogActions"
import DialogContent from "src/components/DialogContent"
import DialogTitle from "src/components/DialogTitle"
import ColorInput from "src/components/MuiColorInput"
import ParametreGrupEnum from "src/enums/ParametreGrupEnum"
import { translate } from "src/i18n/tHelper"
import VwSonucIzlemeTanimDTO from "src/models/Settings/Generals/VwSonucIzlemeTanimDTO"
import GnlParametreSelect from "src/parts/Genel/gnl.parametre.select"
import { useSonucIzlemeTanimDuzenleMutation, useSonucIzlemeTanimEkleMutation } from "src/services/geneltanimlar/SonucIzlemeTanimApi"
import { useAppDispatch, useAppSelector } from "src/store"
import { SonucIzlemeTanimSlice } from "src/store/Slices/GenelTanimlar/SonucIzlemeTanimSlice"
import SnackbarUtils from "src/utils/SnackbarUtils"

const translatePath = "pages|genelTanimlar|sonucIzlemeTanim"
const SonucIzlemeTanimEkle = (): JSX.Element => {

    const state = useAppSelector(state => state.sonucIzlemeTanim);
    const dispatch = useAppDispatch();
    const [ekle, ekleState] = useSonucIzlemeTanimEkleMutation();
    const [duzenle, duzenleState] = useSonucIzlemeTanimDuzenleMutation();
    const grupId = state.testGrubu?.key === 7
        ? ParametreGrupEnum.LaboratuvarPatolojiNumuneDurumları
        : ParametreGrupEnum.IslemDurumu;
    const formik = useFormik<VwSonucIzlemeTanimDTO>({
        enableReinitialize: true,
        initialValues: {
            ...state.activeRow,
        },
        validateOnChange: false,
        async onSubmit(values) {

            if (!state.edit) {
                if (!ekleState.isLoading && !duzenleState.isLoading) {
                    try {

                        var req = new VwSonucIzlemeTanimDTO();
                        req.testGrupId = state.testGrubu.key;
                        req.aktif = values.aktif;
                        req.durumId = values.durumId;
                        req.bgRenk = values.bgRenk;
                        req.txRenk = values.txRenk;


                        await ekle(req)
                            .unwrap()
                            .then((response) => {
                                if (response.responseCode && response.responseCode != 200) {
                                    SnackbarUtils.error(translate(translatePath, 'Kayıt eklenirken bir hata oluştu.'));
                                } else {
                                    SnackbarUtils.success(translate(translatePath, 'Kayıt başarıyla eklendi.'));

                                }

                            })
                            .catch((e) => {
                                SnackbarUtils.error(translate(translatePath, 'Kayıt eklenirken bir hatayla karşılaşıldı.'));
                            });
                        dispatch(SonucIzlemeTanimSlice.actions.setOpen(false));
                        dispatch(SonucIzlemeTanimSlice.actions.setEdit(false));

                    } catch (error: any) {
                        SnackbarUtils.error(error.message);
                    }
                }
            } else {

                await duzenle(values)
                    .unwrap()
                    .then((response) => {

                        if (response.responseCode && response.responseCode != 200) {
                            SnackbarUtils.error(translate(translatePath, 'Kayıt düzenlenirken bir hata oluştu.'));
                        }
                        
                    })
                    .catch((e) => {
                        SnackbarUtils.error(translate(translatePath, 'Kayıt düzenlenirken bir hatayla karşılaşıldı.'));
                    });
                dispatch(SonucIzlemeTanimSlice.actions.setOpen(false));
                dispatch(SonucIzlemeTanimSlice.actions.setEdit(false));

            }
        }
    });

    const handleClose = () => {
        dispatch(SonucIzlemeTanimSlice.actions.setActiveRow(new VwSonucIzlemeTanimDTO()));
        dispatch(SonucIzlemeTanimSlice.actions.setOpen(false));
        dispatch(SonucIzlemeTanimSlice.actions.setEdit(false));

    }
   const handleSave = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (!ekleState.isLoading && !duzenleState.isLoading)
            formik.submitForm();
    }

    return (
        <Dialog fullWidth open={state.open} maxWidth="sm">
            <DialogTitle>{translate(translatePath, `Sonuç İzeme Tanım ${state.edit ? "Düzenle" :"Ekle"}`)}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <GnlParametreSelect
                            required={true}
                            filterCode={[1, 7]}
                            parametreType={ParametreGrupEnum.TestGruplari}
                            label={translate(translatePath, "Test Grubu")}
                            name="grupId"
                            value={formik.values.testGrupId}
                            disabled
                            error={Boolean(formik.errors.testGrupId)}
                            helperText={formik.errors.testGrupId}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <GnlParametreSelect
                            required={true}
                            parametreType={grupId}
                            label={translate(translatePath, "İşlem Durumu")}
                            name="adi"
                            value={formik.values.durumId}
                            disabled
                            error={Boolean(formik.errors.testGrupId)}
                            helperText={formik.errors.testGrupId}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ColorInput label={translate(translatePath,"Arka Plan Rengi")} name="bgRenk" format="hex" value={formik.values.bgRenk} onChange={(newValue) => {
                            formik.setFieldValue('bgRenk', newValue);
                        }} />
                         <ColorInput label={translate(translatePath,"Yazı Rengi")} name="txRenk" format="hex" value={formik.values.txRenk} onChange={(newValue) => {
                            formik.setFieldValue('txRenk', newValue);
                        }} />
                    </Grid>

                    <Grid item xs={12}>
                        <Checkbox
                            label={translate(translatePath, 'Aktif')}
                            name="aktif"
                            onChange={(e) => {
                                const newValue = e.target.checked ? "E" : "H";
                                formik.setFieldValue('aktif', newValue);
                            }}
                            checked={formik.values.aktif === "E"}
                            sx={{ width: "auto" }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button customType="save" disabled={!formik.dirty} onClick={handleSave}  loading={ekleState.isLoading || duzenleState.isLoading} />
                <Button customType="cancel" onClick={handleClose} disabled={ekleState.isLoading || duzenleState.isLoading} />
            </DialogActions>
        </Dialog>
    )
}

export default SonucIzlemeTanimEkle